firebird.controller('securitySettingsCtrl', [
    '$rootScope',
    '$scope',
    'analyticsWrapperService',
    'attendeeService',
    'helperService',
    'logService',
    'meetingService',
    'phoneConferenceService',
    'socketService',
    'meetingNotesService',
    'localizationService',
    function (
        $rootScope,
        $scope,
        analyticsWrapperService,
        attendeeService,
        helperService,
        logService,
        meetingService,
        phoneConferenceService,
        socketService,
        meetingNotesService,
        localizationService
    ) {
        var self = this;

        self.initialSettings = {
            canMuteOthers: true,
            canUnmuteAudio: true,
            canUnmuteWebcam: true,
            canShareScreenOrVideo: true,
            canUseMeetingChat: true,
            canUseMeetingNotes: true,
            canUseMeetingPrivateChat: false,
            canUseTheme: true,

            ignoreCanUnmuteAudio: false,
            autoLockMeeting: false
        };

        self.settings = {
            canMuteOthers: true,
            canUnmuteAudio: true,
            canUnmuteWebcam: true,
            canShareScreenOrVideo: true,
            canUseMeetingChat: true,
            canUseMeetingNotes: true,
            canUseMeetingPrivateChat: false,
            canUseTheme: true,

            ignoreCanUnmuteAudio: false,
            autoLockMeeting: false
        };

        self.firstShown = false;
        self.isSinglePIN = false;
        self.phonePairingPIN = 0;
        self.showAlertForUnpairedSinglePinUnmuting = showAlertForUnpairedSinglePinUnmuting;
        self.shouldShowAutolockSetting = shouldShowAutolockSetting;
        self.shouldShowUseChatSetting = shouldShowUseChatSetting;
        self.shouldShowUseNotesSetting = shouldShowUseNotesSetting;
        self.shouldShowPrivateChatSetting = shouldShowPrivateChatSetting;
        self.shouldShowHolidayThemeSetting = shouldShowHolidayThemeSetting;
        self.getChatOptionsTooltip = getChatOptionsTooltip;
        self.getNotesOptionsTooltip = getNotesOptionsTooltip;
        self.canChangeChatSettings = canChangeChatSettings;
        self.canChangeNotesSettings = canChangeNotesSettings;
        self.resetSettings = resetSettings;
        self.cancel = cancel;
        self.save = save;

        // Meeting Settings events
        $scope.$on('settings-view-state-change', onSettingsViewStateChanged);
        $scope.$on('settings-modal-closed', onSettingsModalClosed);

        $rootScope.$on('security-settings-updated', onSecuritySettingsUpdated);

        init();

        ////////////////////////

        function init() {
            logService.log('securitySettingsCtrl init');

            var info = phoneConferenceService.getPhoneData();
            self.isSinglePIN = info.isSinglePIN;

            self.phonePairingPIN = attendeeService.getAudioPin();

            // Get values from Node server
            if (helperService.getIsRedesign()) {
                if (!self.firstShown) {
                    self.firstShown = true;
                    updateMeetingSecuritySettingsScreen(meetingService.getMeetingSecuritySettings());
                }
            }
        }

        function resetSettings() {
            for (var setting in self.initialSettings) {
                self.settings[setting] = self.initialSettings[setting];
            }
        }

        function updateMeetingSecuritySettingsScreen(meetingSecuritySettings) {
            if (meetingSecuritySettings && meetingSecuritySettings !== '') {
                // Only use the settings already defined in initialSettings
                for (var setting in self.initialSettings) {
                    if (meetingSecuritySettings.hasOwnProperty(setting)) {
                        self.initialSettings[setting] = meetingSecuritySettings[setting];
                        self.settings[setting] = meetingSecuritySettings[setting];
                    }
                }
            }
        }

        function onSecuritySettingsUpdated(e, meetingSecuritySettings) {
            updateMeetingSecuritySettingsScreen(meetingSecuritySettings);
            digest();
        }

        function showAlertForUnpairedSinglePinUnmuting() {
            return (
                self.isSinglePIN === true &&
                attendeeService.getIsHost() === true &&
                self.settings.canUnmuteAudio === false &&
                self.settings.ignoreCanUnmuteAudio === true &&
                self.initialSettings.canUnmuteAudio
            );
        }

        function shouldShowAutolockSetting() {
            return meetingService.isMeeting() && attendeeService.getIsHost();
        }

        function shouldShowUseChatSetting() {
            return meetingService.isMeeting() && attendeeService.getIsHost();
        }

        function shouldShowUseNotesSetting() {
            return meetingNotesService.hasMeetingNotes() && meetingService.isMeeting() && attendeeService.getIsHost();
        }

        function shouldShowHolidayThemeSetting() {
            return meetingService.isMeeting() && attendeeService.getIsHost();
        }

        function shouldShowPrivateChatSetting() {
            return meetingService.getMeetingPrivateChatEnabled();
        }

        function save() {
            var updatedSettings = {},
                hasChanged = false;

            for (var setting in self.settings) {
                if (setting === 'canUseTheme') {
                    $rootScope.$broadcast('themed-features-toggled', { enabled: self.settings[setting] });
                }
                if (self.settings[setting] !== self.initialSettings[setting]) {
                    logService.log('Saving ' + setting + ' value to server:', self.settings[setting]);

                    analyticsWrapperService.eventTrack('Meeting - Security - ' + setting + ' Checkbox Toggled');

                    hasChanged = true;
                }

                updatedSettings[setting] = self.settings[setting];
            }

            if (hasChanged === true) {
                socketService.send({
                    message: 'update-security-settings',
                    data: updatedSettings
                });

                // TODO needs some sort of callback or save confirmation mechanism
            }
        }

        function cancel() {
            self.resetSettings();
        }

        function onSettingsViewStateChanged(e, data) {
            if (data) {
                var tabName = 'security-settings';

                if (data.openedTab === tabName) {
                    logService.log('Security Settings Tab opened');
                } else if (data.closedTab === tabName) {
                    logService.log('Security Settings Tab closed');
                }
            }
        }

        function onSettingsModalClosed(e, data) {
            if (data && data.applyChanges) {
                logService.log('Security Settings - applying changes');
                self.save();
            } else {
                logService.log('Security Settings - closing without applying changes');
                self.cancel();
            }
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }

        function canChangeChatSettings() {
            return !meetingService.e2eeEnabled();
        }

        function getChatOptionsTooltip() {
            if (!meetingService.e2eeEnabled()) {
                return '';
            }

            return localizationService.translate('SECURITY_SETTINGS.TOOLTIP.E2EE_CHAT_DISABLED');
        }

        function canChangeNotesSettings() {
            return !meetingService.e2eeEnabled();
        }

        function getNotesOptionsTooltip() {
            if (!meetingService.e2eeEnabled()) {
                return '';
            }

            return localizationService.translate('SECURITY_SETTINGS.TOOLTIP.E2EE_NOTES_DISABLED');
        }
    }
]);
